import { createFileRoute } from '@tanstack/react-router';
import { BoardPage } from '../board/index';
import { MyDealsFilteredDealsProvider } from '../my-deals/index';

export const Route = createFileRoute('/(authenticated)/$hub/my-deals-board/')({
  component: MyDealsBoardPageWrapper,
  staticData: {
    keepAlive: true,
  },
});

function MyDealsBoardPageWrapper() {
  return (
    <div>
      <MyDealsFilteredDealsProvider>
        <BoardPage />
      </MyDealsFilteredDealsProvider>
    </div>
  );
}
